import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';

import { ApiRequestDescriptor } from '../../services';

export interface LoadDocumentByUrlRequestArgs {
  url: string;
}

export const loadDocumentByUrlRequest = ({
  url,
}: LoadDocumentByUrlRequestArgs): ApiRequestDescriptor => ({
  url,
  config: {
    method: SUPPORTED_METHODS.GET,
    responseType: 'blob',
  },
});
